/* WE DO THINGS DIFFERENT - plays each icon once when the strip scrolls into view, and again on hover (mouse) or tap.
   data-state on each cell: idle (hidden start) -> play -> done. Skipped entirely when the section's Animate box is off or the visitor
   asked for reduced motion: then no state is set and the CSS shows the finished icons. */
(function () {
  'use strict';
  var STEP = 140;      // ms between one icon and the next
  var NEEDLE_MS = 1250; // must match usp-draw in racing-usp.css
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function needle(cell, delay) {
    var n = cell.querySelector('.usp-needle');
    var g = cell.querySelector('.usp-guide');
    if (!n || !g || !n.animate || !g.getTotalLength) return;
    var len = g.getTotalLength();
    var frames = [];
    var steps = 40;
    for (var i = 0; i <= steps; i++) {
      var p = g.getPointAtLength(len * i / steps);
      frames.push({ transform: 'translate(' + p.x.toFixed(2) + 'px,' + p.y.toFixed(2) + 'px)', opacity: 1, offset: i / steps });
    }
    if (cell._needle) cell._needle.cancel();
    cell._needle = n.animate(frames, { duration: NEEDLE_MS, delay: delay, easing: 'cubic-bezier(.3,.6,.25,1)', fill: 'both' });
  }

  function play(cell, index) {
    if (cell.getAttribute('data-state') === 'play') return;
    var delay = index * STEP;
    cell.style.setProperty('--usp-d', delay + 'ms');
    cell.setAttribute('data-state', 'idle');
    void cell.getBoundingClientRect(); // restart the CSS animations
    cell.setAttribute('data-state', 'play');
    needle(cell, delay);
    window.clearTimeout(cell._done);
    cell._done = window.setTimeout(function () {
      cell.setAttribute('data-state', 'done');
      if (cell._needle) { cell._needle.cancel(); cell._needle = null; }
    }, delay + 1900);
  }

  // real clips: silent loops cut from Hat Dealers footage. They play only while on screen; reduced motion (or the section's Play box off) keeps the still.
  function clipFailed(v) {
    var cell = v.closest ? v.closest('.rsx-usp__cell') : null;
    if (cell) cell.setAttribute('data-clip', 'failed');
  }
  function playClip(v) {
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function watchClips(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll('video[data-rsx-clip]'));
    if (!vids.length) return;
    var on = root.getAttribute('data-clips') !== 'false' && !reduce;
    vids.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.addEventListener('error', function () { clipFailed(v); });
      if (v.error || v.networkState === 3) clipFailed(v);
      if (!on) {
        v.removeAttribute('autoplay');
        v.pause();
        try { v.currentTime = 0; } catch (e) { /* not seekable yet: the still shows anyway */ }
      }
    });
    if (!on) return;
    if (!('IntersectionObserver' in window)) { vids.forEach(playClip); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) playClip(e.target); else e.target.pause();
      });
    }, { threshold: 0.25 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function setup(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    watchClips(root);
    if (reduce || root.getAttribute('data-animate') === 'false') return;
    var cells = Array.prototype.slice.call(root.querySelectorAll('.rsx-usp__cell'));
    cells.forEach(function (c, i) {
      c.setAttribute('data-state', 'idle');
      var again = function () { play(c, 0); };
      c.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') again(); });
      c.addEventListener('click', again);
    });
    var run = function () { cells.forEach(function (c, i) { play(c, i); }); };
    if (!('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.disconnect(); run(); }
      });
    }, { threshold: 0.35 });
    io.observe(root.querySelector('.rsx-usp__card') || root);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-rsx-usp]'), setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init); // theme editor: the section was re-rendered
})();
